// Phase H+1 Wave 4 · additive i18n patch per chiavi header_v3 legacy mancanti.
//
// Il bundle legacy `components/header-v3/i18n/header-v3.{it,en}.json` è
// sealed (zero-touch). Alcune chiavi `admin_menu.item.*` sono state
// aggiunte al menuGroups legacy senza traduzione corrispondente nel
// bundle (es. `admin_menu.item.admin_social`, `admin_menu.item.admin_affiliates`).
//
// Risultato visibile: le voci mostrano la chiave raw nell'UI legacy e
// nel V12 mega-menu (quando il hook i18n legacy fa il lookup).
//
// Soluzione additiva: usiamo `i18n.addResource` per aggiungere le
// chiavi mancanti al bundle `header_v3` runtime. Zero modifiche al
// file JSON legacy sealed · fallback automatico IT→EN se mancante.
//
// Da chiamare una volta al bootstrap dell'app (post i18n.init).

import i18n from "i18next";

const PATCHES = {
    it: {
        header_v3: {
            "admin_menu.item.admin_social": "Admin Social",
            "admin_menu.item.admin_affiliates": "Gestione affiliati",
        },
    },
    en: {
        header_v3: {
            "admin_menu.item.admin_social": "Admin Social",
            "admin_menu.item.admin_affiliates": "Affiliate Management",
        },
    },
};

let _applied = false;

export function applyLegacyAdminMenuPatches() {
    if (_applied) return;
    _applied = true;
    try {
        for (const [lng, namespaces] of Object.entries(PATCHES)) {
            for (const [ns, pairs] of Object.entries(namespaces)) {
                for (const [key, value] of Object.entries(pairs)) {
                    // addResource · deep=true consente chiavi flat con punti.
                    i18n.addResource(lng, ns, key, value, {
                        keySeparator: false,
                        silent: true,
                    });
                }
            }
        }
    } catch (e) {
        // Silent · non bloccare bootstrap app se i18n non è pronto.
        // eslint-disable-next-line no-console
        console.warn("[v12-legacy-i18n-patch] skipped:", e);
    }
}
